import { render, staticRenderFns } from "./AnnouncementTargetList.vue?vue&type=template&id=50dfd72d&scoped=true"
import script from "./AnnouncementTargetList.vue?vue&type=script&lang=js"
export * from "./AnnouncementTargetList.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementTargetList.vue?vue&type=style&index=0&id=50dfd72d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dfd72d",
  null
  
)

export default component.exports